import type { RoleModule } from '../types';
/* General Sans — the kit's face; see technician.css. */
import '@/components/kit/fonts.css';
import './technician.css';
import { TechWorklistPage } from './TechWorklistPage';
import { TechCapturePage } from './TechCapturePage';
import { TechCantPage } from './TechCantPage';
import { TechHandOverPage } from './TechHandOverPage';
import { TechBundlePage } from './TechBundlePage';
import { TechDayPage } from './TechDayPage';
import { TechStockPage } from './TechStockPage';

/**
 * The technician surface's routes and door overrides. See ../types.ts.
 * Every route path here must start with `/technician/`.
 */
const technician: RoleModule = {
  routes: [
    { path: '/technician/worklist', element: <TechWorklistPage /> },
    { path: '/technician/worklist/hand-over', element: <TechHandOverPage /> },
    { path: '/technician/worklist/:id', element: <TechCapturePage /> },
    { path: '/technician/worklist/:id/cant', element: <TechCantPage /> },
    { path: '/technician/bundle/:id', element: <TechBundlePage /> },
    { path: '/technician/day', element: <TechDayPage /> },
    { path: '/technician/stock', element: <TechStockPage /> },
  ],
  doorRoutes: {
    worklist: '/technician/worklist',
    myday: '/technician/day',
    stock: '/technician/stock',
  },
};

export default technician;
